import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]

import {
    ref,
    toRefs,
    computed,
} from 'vue'
import { useFocus } from '@vueuse/core';
import { QInput } from 'quasar';

// Personal libs
import { $t } from 'src/i18n/utils';
import { checkEmail } from '@shared/lib/security.lib';
import {
    emailRules,
    emailExample
} from '@shared/lib/form.lib';

/**
 * HTMLElement refs
 */
interface QInputEmailProps {
    // Model
    modelValue?: string

    // Content
    label: string
    placeholder?: string
    ariaDescribedBy?: string
    showAriaDescription?: boolean

    // Style
    extraClass?: string;
    dense?: boolean

    // State
    disable?: boolean
    required?: boolean
   
    // Actions
    onEnterKey?: (...args: any[]) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QInputEmail',
  props: {
    modelValue: {},
    label: {},
    placeholder: { default: undefined },
    ariaDescribedBy: {},
    showAriaDescription: { type: Boolean, default: false },
    extraClass: {},
    dense: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    required: { type: Boolean, default: true },
    onEnterKey: { type: Function, default: undefined }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

// Vendor
const customQInputEmail = ref<QInput>();
const { focused: customQInputEmailFocused } = useFocus(customQInputEmail);

/**
 * Properties
 */
const props = __props;
const {
    onEnterKey,
    required,
    label,
    placeholder,
    ariaDescribedBy,
    extraClass,
    disable,
    dense,
    modelValue
} = toRefs(props);

/**
 * Events
 */
const emit = __emit

/**
 * Computed properties
 */
// If required, add a star at the beginning of the label
const computedLabel = computed<string>(() => `${required.value ? '* ' : ''}${label.value}`)

/**
 * Methods
 */
function clearEmail() {
    customQInputEmail.value?.resetValidation();
    emit('update:modelValue', undefined)
    customQInputEmailFocused.value = true;
}

function hasError() {
    return customQInputEmail.value?.hasError
}

function validate() {
    customQInputEmail.value?.validate()
}

function resetValidation() {
    customQInputEmail.value?.resetValidation()
}

/**
 * Exposed methods
 */
__expose({
    clearEmail,
    hasError,
    validate,
    resetValidation
})

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(ariaDescribedBy) == null)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
                'q-mx-sm': true,
                'sr-only': _ctx.showAriaDescription === false
            }),
          id: _unref(ariaDescribedBy) ?? 'id_example_email'
        }, " Exemple d'email : " + _toDisplayString(_unref(emailExample)), 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createVNode(_unref(QInput), {
      "model-value": _unref(modelValue),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (newValue) => emit('update:modelValue', newValue)),
      ref_key: "customQInputEmail",
      ref: customQInputEmail,
      dense: _unref(dense),
      placeholder: _unref(placeholder),
      "aria-required": _unref(required),
      "aria-describedby": _unref(ariaDescribedBy) ?? 'id_example_email',
      "aria-invalid": _unref(checkEmail)(_unref(modelValue) ?? '') ? 'false' : 'true',
      "aria-disable": _unref(disable),
      disable: _unref(disable),
      label: computedLabel.value,
      type: "email",
      outlined: "",
      autocomplete: "email",
      "bg-color": _ctx.$q.dark.isActive ? 'black' : 'white',
      "label-color": _ctx.$q.dark.isActive ? 'white' : 'black',
      class: _normalizeClass(['q-mb-sm', _unref(extraClass)]),
      "input-class": [
                _ctx.$q.dark.isActive ? 'text-white' : 'text-black',
                'set-outline',
            ],
      "hide-bottom-space": "",
      "lazy-rules": "",
      rules: _unref(emailRules),
      enterkeyhint: "done",
      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_unref(onEnterKey) != null ? _unref(onEnterKey)() : undefined), ["enter"]))
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_q_icon, { name: "mail" })
      ]),
      append: _withCtx(() => [
        _createVNode(_component_q_btn, {
          flat: "",
          round: "",
          dense: "",
          icon: "cancel",
          class: "set-outline",
          color: "primary",
          disable: _unref(disable),
          title: _unref($t)('form.email.reset'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clearEmail()), ["stop"]))
        }, null, 8 /* PROPS */, ["disable", "title"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value", "dense", "placeholder", "aria-required", "aria-describedby", "aria-invalid", "aria-disable", "disable", "label", "bg-color", "label-color", "class", "input-class", "rules"])
  ]))
}
}

})